import { store } from "src/stateManagement/store";


export async function callEndpoint<Arg, Result>(
    endpoint: any,
    arg?: Arg,
    customError?: string
): Promise<Result> {
    const sub = store.dispatch((endpoint as any).initiate(arg));
    try {
        const data = await sub.unwrap();
        if (data?.error) throw new Error(customError ?? `Ошибка запроса ${endpoint}`)
        return data as Result;
    } catch (error: any) {
        console.error(customError ?? error);
        return null as Result;
    } finally {
        sub.unsubscribe();
    }
}